import React from "react";
import "./index.css";
import { color, styled } from "@mui/system";

import { useDarkMode } from "src/components/context/DarkModeContext";

const SystemLoader = ({ text = "Loading...", name = "KRISHPAR" }) => {

  const { isDarkMode } = useDarkMode();

  const theme = isDarkMode
    ? `background: radial-gradient(circle at center,rgb(6, 6, 6) 0%,rgb(42, 54, 48) 100%);`
    : `background: radial-gradient(circle at center,rgb(243, 249, 252) 0%,rgb(241, 245, 243) 100%);`

  const LoaderContainer = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  ${theme}
`;

  const LoaderWrapper = styled("div")`
  width: 200px;
  height: 200px;
  position: relative;
`;

  return (
    <LoaderContainer>
      <LoaderWrapper>
        <div className="scanner"></div>
        <svg width="100%" height="100%" viewBox="0 0 100 100" style={{ transform: "rotate(-90deg)" }}>
          <circle className="circle outer" cx="50" cy="50" r="45" />
          <circle className="circle middle" cx="50" cy="50" r="35" />
          <circle className="circle inner" cx="50" cy="50" r="25" />
          <circle className="dots" cx="50" cy="5" r="2" />
          <circle className="dots" cx="95" cy="50" r="2" />
          <circle className="dots" cx="50" cy="95" r="2" />
          <circle className="dots" cx="5" cy="50" r="2" />
        </svg>
        <div className="center-text">{name}</div> {/* Centered name */}
        <div className="progress-text" style={{ color: '#0dac20' }}>{text}</div>
      </LoaderWrapper>
    </LoaderContainer>
  );
};


export default SystemLoader;
